/**
 * Authentication Storage Utility
 * 
 * Centralized storage management for authentication tokens.
 * Uses sessionStorage to ensure tokens are cleared when browser closes.
 */

export const authStorage = {
  /**
   * Store authentication token
   * @param {string} token - The authentication token to store
   */
  setToken(token) {
    if (token) {
      sessionStorage.setItem('token', token);
    }
  },

  /**
   * Retrieve authentication token
   * @returns {string|null} The stored token or null if not found
   */
  getToken() {
    return sessionStorage.getItem('token');
  },

  /**
   * Remove authentication token
   */
  removeToken() {
    sessionStorage.removeItem('token');
  },

  /**
   * Clear all authentication data from storage
   */
  clearAll() {
    sessionStorage.removeItem('token');
    // Clear any other auth-related data if needed
  },

  /**
   * Check if token exists in storage
   * @returns {boolean} True if token exists
   */
  hasToken() {
    return !!sessionStorage.getItem('token');
  },

  /**
   * Migrate from localStorage to sessionStorage (one-time migration)
   * This can be called on app initialization to migrate existing tokens
   */
  migrateFromLocalStorage() {
    const oldToken = localStorage.getItem('token');
    if (oldToken) {
      // Move token to sessionStorage
      sessionStorage.setItem('token', oldToken);
      // Remove from localStorage
      localStorage.removeItem('token');
    }
  },
};

export default authStorage;